module.exports = __webpack_public_path__ + "static/media/portfolio1 (9).8f76b38a.jpeg";